import React from 'react';
import '../template-file-css/document-file-template.css';


export const EYPC_ClinicalSupervisionLog = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='EYPC_ClinicalSupervisionLog' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <span className='eleHeader'>Clinical Supervisor/Credentials:</span>
                    <input type='text' id='txtClinicalSupervisorCredetials' name='txtClinicalSupervisorCredetials' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Supervision By:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Date of Supervision:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbSupervisionBy_Individual' name='rbSupervisionBy' className='add-only' value='Individual' /> Individual&nbsp;
                            <input type='radio' id='rbSupervisionBy_Group' name='rbSupervisionBy' className='add-only' value='Group' /> Group
                        </td>
                        <td className='w-375'> <input type='date' id='txtDateOfSupervision' name='txtDateOfSupervision' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Supervision Type:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbSupervisionType_ClinicalDocSupport' name='rbSupervisionType' className='add-only' value='ClinicalDocSupport' /> Clinical Doc. Support &nbsp;
                            <input type='radio' id='rbSupervisionType_CaseReview' name='rbSupervisionType' className='add-only' value='CaseReview' /> Case Review &nbsp;
                            <input type='radio' id='rbSupervisionType_ProfessionalDevelopmentTraining' name='rbSupervisionType' className='add-only' value='ProfessionalDevelopmentTraining' /> Professional Development/Training
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Individual's Risk Assessment:-</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-45'>
                            <span className='eleHeader'>S/N</span>
                        </td>
                        <td className='w-365'>
                            <span className='eleHeader'>ASSESSMENT</span>
                        </td>
                        <td className='w-170'>
                            <span className='eleHeader'>CHECK (all that apply)</span>
                        </td>
                        <td className='w-170'>
                            <span className='eleHeader'>REMARKS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-45'>
                            1.
                        </td>
                        <td className='w-365'>
                            Any active SI reported?
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyActiveSiReported_Yes' name='rbAnyActiveSiReported' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyActiveSiReported_No' name='rbAnyActiveSiReported' className='add-only' value='No' /> No
                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtRemarks_1' name='txtRemarks_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-45'>
                            2.
                        </td>
                        <td className='w-365'>
                            Any HI reported
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyActiveHiReported_Yes' name='rbAnyActiveHiReported' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyActiveHiReported_No' name='rbAnyActiveHiReported' className='add-only' value='No' /> No
                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtRemarks_2' name='txtRemarks_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-45'>
                            3.
                        </td>
                        <td className='w-365'>
                            Any new substance abuse issues observed (Not currently addressed on ISP)?
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyNewSubstanceAbuseObserved_Yes' name='rbAnyNewSubstanceAbuseObserved' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyNewSubstanceAbuseObserved_No' name='rbAnyNewSubstanceAbuseObserved' className='add-only' value='No' /> No
                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtRemarks_3' name='txtRemarks_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-45'>
                            4.
                        </td>
                        <td className='w-365'>
                            Any new traumas or safety concerns?
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyNewTraumasOrSafetyConcerns_Yes' name='rbAnyNewTraumasOrSafetyConcerns' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyNewTraumasOrSafetyConcerns_No' name='rbAnyNewTraumasOrSafetyConcerns' className='add-only' value='No' /> No
                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtRemarks_4' name='txtRemarks_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-45'>
                            5.
                        </td>
                        <td className='w-365'>
                            5	Any hospitalizations (medical or psychiatric) or major injuries?
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyHospitalizationMajorInjuries_Yes' name='rbAnyHospitalizationMajorInjuries' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyHospitalizationMajorInjuries_No' name='rbAnyHospitalizationMajorInjuries' className='add-only' value='No' /> No
                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtRemarks_5' name='txtRemarks_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-45'>
                            6.
                        </td>
                        <td className='w-365'>
                            Any reportable incidents (CPS, APS, Police, etc.?)
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyReportableIncidentsCPSAPSPoliceEtc_Yes' name='rbAnyReportableIncidentsCPSAPSPoliceEtc' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyReportableIncidentsCPSAPSPoliceEtc_No' name='rbAnyReportableIncidentsCPSAPSPoliceEtc' className='add-only' value='No' /> No
                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtRemarks_6' name='txtRemarks_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-45'>
                            7.
                        </td>
                        <td className='w-365'>
                            Any new legal charges/incidents?
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyNewLegalChargesIncidents_Yes' name='rbAnyNewLegalChargesIncidents' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAnyNewLegalChargesIncidents_No' name='rbAnyNewLegalChargesIncidents' className='add-only' value='No' /> No
                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtRemarks_7' name='txtRemarks_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-45'>
                            8.
                        </td>
                        <td className='w-365'>
                            Lapse in Service more than 15 days?
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbLapseInServiceMoreThanDays_Yes' name='rbLapseInServiceMoreThanDays' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbLapseInServiceMoreThanDays_No' name='rbLapseInServiceMoreThanDays' className='add-only' value='No' /> No
                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtRemarks_8' name='txtRemarks_8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-45'>
                            9.
                        </td>
                        <td className='w-365'>
                            Attempts Made To Outpatient/ Community Supports
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAttemptsMadeToOutpatientCommunitySupports_Yes' name='rbAttemptsMadeToOutpatientCommunitySupports' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbAttemptsMadeToOutpatientCommunitySupports_No' name='rbAttemptsMadeToOutpatientCommunitySupports' className='add-only' value='No' /> No
                        </td>
                        <td className='w-170'>
                            <input type='text' id='txtRemarks_9' name='txtRemarks_9' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If Yes to any of the questions above, please provide details:</span>
                    <textarea id='txtIfYesToAnyOfTheQuestionsAbovePleaseProvideDetails' name='txtIfYesToAnyOfTheQuestionsAbovePleaseProvideDetails' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Clinical Recommendations/Follow Up/ Action Plan Below</span>
                    <span className='small'>(include recommendations for ISP revisions, if needed):</span>
                    <textarea id='txtClinicalRecommendationsFollowUpActionPlanBelow' name='txtClinicalRecommendationsFollowUpActionPlanBelow' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>Medication/Dosage Updates:</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Did Medication change since last Supervision?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbDidMedicationChangeSincelastSupervision_Yes' name='rbDidMedicationChangeSincelastSupervision' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbDidMedicationChangeSincelastSupervision_No' name='rbDidMedicationChangeSincelastSupervision' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbDidMedicationChangeSincelastSupervision_NA' name='rbDidMedicationChangeSincelastSupervision' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Individual Record updated (Intake Notified)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbIndividualRecordupdatedIntakeNotified_Yes' name='rbIndividualRecordupdatedIntakeNotified' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbIndividualRecordupdatedIntakeNotified_No' name='rbIndividualRecordupdatedIntakeNotified' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbIndividualRecordupdatedIntakeNotified_NA' name='rbIndividualRecordupdatedIntakeNotified' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Name of Provider</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Date of Change</span> </td>
                        <td className='w-300'> <span className='eleHeader'>Description of Change (s)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtNameOfProvider' name='txtNameOfProvider' className='add-only' /> </td>
                        <td className='w-150'> <input type='date' id='txtDateOfChange' name='txtDateOfChange' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtLastName' name='txtLastName' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Any Demographic Change(s)?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbAnyDemographicChange_Yes' name='rbAnyDemographicChange' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbAnyDemographicChange_No' name='rbAnyDemographicChange' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbAnyDemographicChange_NA' name='rbAnyDemographicChange' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If yes, Intake Notified?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>
                            <input type='radio' id='rbIfyesIntakeNotified_Yes' name='rbIfyesIntakeNotified' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbIfyesIntakeNotified_No' name='rbIfyesIntakeNotified' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>
                            <input type='radio' id='rbIfyesIntakeNotified_NA' name='rbIfyesIntakeNotified' className='add-only' value='NA' /> N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>CLINICAL CASE REVIEW</h3>
                    <span className='small'>(May be skipped if Clinician is only doing professional development/Training)</span>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(1) What Goals were discussed/worked on since last supervision?</span>
                    <textarea id='txtWhatGoalsWereDiscussedWorkedOnSinceLastSupervision' name='txtWhatGoalsWereDiscussedWorkedOnSinceLastSupervision' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(2) What Specific Interventions(s) did the QMHP/QPPMH utilize since last supervision?</span>
                    <textarea id='txtWhatSpecificInterventionssDidTheQMHPQPPMHUtilizeSinceLastSupervision' name='txtWhatSpecificInterventionssDidTheQMHPQPPMHUtilizeSinceLastSupervision' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(3) What are some challenges/presenting issues observed since last supervision?</span>
                    <textarea id='txtWhatAreSomeChallengesPresentingIssuesObservedSinceLastSupervision' name='txtWhatAreSomeChallengesPresentingIssuesObservedSinceLastSupervision' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(4) What Specific Intervention(s),  Strategy OR Task(s) does the Clinician recommend to address current challenges?</span>
                    <textarea id='txtWhatSpecificInterventionsStrategyORTasksDoesTheClinicianRecommendToAddressCurrentChallenges' name='txtWhatSpecificInterventionsStrategyORTasksDoesTheClinicianRecommendToAddressCurrentChallenges' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>CLINICAL DIRECTION/RECOMMENDATIONS</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> (1) Any professional/Staff related concerns?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbAnyProfessionalStaffRelatedConcerns_Yes' name='rbAnyProfessionalStaffRelatedConcerns' className='add-only' value='Yes' /> Yes&nbsp;
                            <input type='radio' id='rbAnyProfessionalStaffRelatedConcerns_No' name='rbAnyProfessionalStaffRelatedConcerns' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>If Yes Please Describe</b>
                    <textarea id='txtIfYesPleaseDescribe' name='txtIfYesPleaseDescribe' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(2) Upcoming/Past Due Documentation:</span>
                    <input type='text' id='txtUpcomingPastDueDocumentation' name='txtUpcomingPastDueDocumentation' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>(3) Additional Recommendations/Clinical Direction:</span>
                    <textarea id='txtAdditionalRecommendationsClinicalDirection' name='txtAdditionalRecommendationsClinicalDirection' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Next Supervision:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtDateOfNextSupervision' name='txtDateOfNextSupervision' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> QMHP/QPPMH Signature: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Supervisor Signature/Credentials: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}